var map = {
	"./5Mz4 (1).gif": [
		551,
		92
	],
	"./BalloonImgBg.svg": [
		239
	],
	"./BalloonImgBgSm.svg": [
		240
	],
	"./BalloonImgFriend.png": [
		238
	],
	"./BalloonImgTriangle.svg": [
		552,
		27
	],
	"./XZ9.gif": [
		553,
		93
	],
	"./approvingArrow.svg": [
		554,
		28
	],
	"./approvingArrowLinear.svg": [
		555,
		29
	],
	"./arrow-down-blue.svg": [
		556,
		30
	],
	"./arrow-down-grey.svg": [
		557,
		31
	],
	"./arrow-down-metis.svg": [
		558,
		32
	],
	"./arrow-down.svg": [
		559,
		33
	],
	"./arrow-right-white.png": [
		560,
		94
	],
	"./arrow-right.svg": [
		561,
		34
	],
	"./binance-logo.png": [
		531,
		95
	],
	"./binance.svg": [
		562,
		35
	],
	"./blue-loader.svg": [
		530,
		36
	],
	"./check.svg": [
		563,
		37
	],
	"./checkbox--checked.svg": [
		543,
		38
	],
	"./checkbox--hover.svg": [
		544,
		39
	],
	"./checkbox2--checked.svg": [
		564,
		40
	],
	"./checkbox2--hover.svg": [
		565,
		41
	],
	"./circle-grey.svg": [
		566,
		42
	],
	"./circle.svg": [
		567,
		43
	],
	"./clock.gif": [
		236
	],
	"./close-metis.svg": [
		568,
		44
	],
	"./close.svg": [
		569,
		45
	],
	"./coin.svg": [
		570,
		46
	],
	"./coin98.svg": [
		571,
		47
	],
	"./dropdown-blue.svg": [
		572,
		48
	],
	"./dropdown.svg": [
		573,
		49
	],
	"./dropup-blue.svg": [
		574,
		50
	],
	"./ethereum-bg.png": [
		234
	],
	"./ethereum-logo.png": [
		575,
		96
	],
	"./exchange.svg": [
		576,
		51
	],
	"./help-metis.svg": [
		577,
		52
	],
	"./help.svg": [
		578,
		53
	],
	"./icon--20-bscscan.svg": [
		579,
		54
	],
	"./icon--20-fd.svg": [
		580,
		55
	],
	"./icon--20-world.svg": [
		581,
		56
	],
	"./icon--arrow.svg": [
		532,
		57
	],
	"./icon--arrows.svg": [
		582,
		58
	],
	"./icon--bnb.png": [
		583,
		97
	],
	"./icon--busd.png": [
		584,
		98
	],
	"./icon--copy.svg": [
		585,
		59
	],
	"./icon--documentation.svg": [
		586,
		60
	],
	"./icon--donations.svg": [
		587,
		61
	],
	"./icon--economic-model.svg": [
		535,
		62
	],
	"./icon--fee01.svg": [
		537,
		63
	],
	"./icon--fee02.svg": [
		538,
		64
	],
	"./icon--fee03.svg": [
		539,
		65
	],
	"./icon--fee04.svg": [
		540,
		66
	],
	"./icon--fee05.svg": [
		541,
		67
	],
	"./icon--financial-model.svg": [
		534,
		68
	],
	"./icon--minus.svg": [
		588,
		69
	],
	"./icon--plus.svg": [
		589,
		70
	],
	"./icon--proposals.svg": [
		590,
		71
	],
	"./icon--sort.svg": [
		591,
		72
	],
	"./icon--statistics.svg": [
		592,
		73
	],
	"./icon--wow.png": [
		593,
		99
	],
	"./icon--your-wallet.svg": [
		533,
		74
	],
	"./img-graf-01@2x.jpg": [
		594,
		100
	],
	"./img-stats-graf-01.jpg": [
		547,
		101
	],
	"./img-stats-graf-02.jpg": [
		548,
		102
	],
	"./img-stats-graf-03.jpg": [
		549,
		103
	],
	"./img-stats-graf-04.jpg": [
		550,
		104
	],
	"./iotex-bg.png": [
		235
	],
	"./link.svg": [
		595,
		75
	],
	"./logo-stc@2x-01.png": [
		545,
		105
	],
	"./logo-tf@2x-01.png": [
		546,
		106
	],
	"./magnifying-glass.svg": [
		596,
		76
	],
	"./mathwallet.svg": [
		597,
		77
	],
	"./menu-square.svg": [
		598,
		78
	],
	"./menu.svg": [
		599,
		79
	],
	"./metamask.png": [
		536,
		107
	],
	"./pikachu.gif": [
		542,
		108
	],
	"./plus-blue.svg": [
		600,
		80
	],
	"./plus-grey.svg": [
		601,
		81
	],
	"./question-mark.svg": [
		602,
		82
	],
	"./question.svg": [
		603,
		83
	],
	"./settings-metis.svg": [
		604,
		84
	],
	"./settings.svg": [
		605,
		85
	],
	"./spinner.svg": [
		606,
		86
	],
	"./trustWallet.png": [
		607,
		109
	],
	"./trustwallet.svg": [
		608,
		87
	],
	"./walletConnectIcon.svg": [
		237
	],
	"./warning.svg": [
		609,
		88
	],
	"./wbnb.png": [
		610,
		110
	],
	"./x.svg": [
		611,
		89
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 525;
module.exports = webpackAsyncContext;